import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.61133 3.255C5.7592 1.10713 9.24078 1.10714 11.3887 3.255C13.3719 5.23824 13.5243 8.35943 11.8447 10.5167L11.5566 10.8868L11.9072 11.1984C11.9116 11.2023 11.9164 11.2066 11.9209 11.2111V11.2101L15.1016 14.3917C15.199 14.4895 15.1991 14.6477 15.1016 14.7452C15.004 14.8428 14.8457 14.8427 14.748 14.7452L11.5654 11.5626C11.5619 11.5591 11.5587 11.5553 11.5557 11.5519L11.2441 11.1993L10.873 11.4884C8.78304 13.1156 5.788 13.0237 3.7998 11.213L3.61133 11.0323L3.41602 10.8273C1.46537 8.66823 1.53059 5.33575 3.61133 3.255ZM11.0352 3.60852C9.08257 1.65589 5.91746 1.6559 3.96484 3.60852C2.01222 5.56114 2.01223 8.72617 3.96484 10.6788C5.91746 12.6314 9.08257 12.6314 11.0352 10.6788C12.9878 8.72618 12.9878 5.56114 11.0352 3.60852Z",
		fill: "currentColor",
		stroke: "currentColor"
	})
});
export default SvgSearchIcon;
